import taraBaseballOneSvg from '../../assets/taraBaseballOne.svg';
import taraBaseballTwoSvg from '../../assets/taraBaseballTwo.svg';
import taraDefaultOneSvg from '../../assets/taraDefaultOne.svg';
import taraDefaultTwoSvg from '../../assets/taraDefaultTwo.svg';
import taraFootballOneSvg from '../../assets/taraFootballOne.svg';
import taraHockeyOneSvg from '../../assets/taraHockeyOne.svg';

const avatars = {
  default: [
    taraDefaultOneSvg,
    taraDefaultTwoSvg,
  ],

  baseball: [
    taraBaseballOneSvg,
    taraBaseballTwoSvg,
  ],

  football: [
    taraFootballOneSvg,
  ],

  hockey: [
    taraHockeyOneSvg,
  ],
};

const initialType = 'baseball';
const initialIndex = 1;

const avatarsQueryTextMap = {
  baseball: [
    'baseball',
    'yankee',
    'ranger',
  ],

  football: [
    'football',
    'test matching with spaces',
  ],

  hockey: [
    'hockey',
  ],
};

const flatQueryTextMap = {};

const avatarKeys = Object.keys(avatarsQueryTextMap);

avatarKeys.forEach((key) => {
  avatarsQueryTextMap[key].forEach((queryText) => {
    flatQueryTextMap[queryText] = key;
  });
});

const watchedQueryTexts = Object.keys(flatQueryTextMap);
const { length } = watchedQueryTexts;

export default function getAvatarFromQueryText(queryText) {
  const searchedQuery = queryText.toLowerCase();

  let index;
  let watchedQuery;

  for (index = 0; index < length; index += 1) {
    watchedQuery = watchedQueryTexts[index];

    if (searchedQuery.indexOf(watchedQuery) > -1) {
      const type = flatQueryTextMap[watchedQuery];
      const index = 0;

      return avatars[type][index];
    }
  }

  return avatars[initialType][initialIndex];
};




// WEBPACK FOOTER //
// ./src/helpers/tara/getAvatarFromQueryText.js